// extracted by mini-css-extract-plugin
module.exports = {"withBanner":"Popover_withBanner__1A2Qq","banner":"Popover_banner__15U0N","withHeader":"Popover_withHeader__1nsLs","header":"Popover_header__1g_9Y"};